import { render, staticRenderFns } from "./LocalHostList.vue?vue&type=template&id=1a04e4e5"
import script from "./LocalHostList.vue?vue&type=script&lang=js"
export * from "./LocalHostList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports